export default {
  SET_DATA(state, value) { state.data = value; },
  SET_OPTIONS(state, value) { state.options = value; },
};
